import Axios from "axios";
import $ from "jquery";

let body = {};

body.generate = (size = 6, isAlpha = false) => {

  const pool = isAlpha ? 'ABCDEFGHIJKLMNPQRSTUVWXYZ0123456789abcdefghijklmnpqrstuvwxyz' : '0123456789';
  const rand = []; let i = -1;

  while (++i < size) rand.push(pool.charAt(Math.floor(Math.random() * pool.length)));

  return rand.join('');

}


body.makeLengthEqual = (id, children, rem = 0) => {

  let heigthList = [];
  const items = $(id).find(children);

  for (let i = 0; i < items.length; i++) {
    heigthList.push(Math.floor($(items[i]).height()))
  }
  const height = Math.max(...heigthList); // get the highest length;

  for (let i = 0; i < items.length; i++) {

    if (Math.floor($(items[i]).height()) !== height) {
      $(items[i]).height(height - rem);
    }

  }

}

body.changeBackground = (cn) => {
  const elem = document.querySelector(".body");

  if (elem) {
    elem.classList.add(cn);
  }
};

body.dismissBackground = (cn) => {
  const elem = document.querySelector(".body");

  if (elem) {
    elem.classList.remove(cn);
  }
};

body.formatStatus = (val) => {
  let flag = {};

  if (val === "ended") {
    flag = { bg: "[#FFD8D8]", col: "[#FF0000]" };
  } else if (val === "active") {
    flag = { bg: "[#D3FCDC]", col: "[#2CB742]" };
  }
  return flag;
};

body.deleteData = async (data, route, id) => {
  const filteredUsers = data.filter((u) => u._id !== id);
  const resp = await Axios.delete(
    `${process.env.REACT_APP_BASE_URL}/${route}/${id}`
  );
};

body.formatCurrency = (currency) => {
  const result = new Intl.NumberFormat("en-NG", {
    currency: "NGN",
    style: "currency",
  });

  return result.format(currency);
};

body.isObjectEmpty = (obj) => {
  return Object.getOwnPropertyNames(obj).length === 0 ? true : false;
};

body.captialize = (s) => {
  return s.charAt(0).toUpperCase() + s.slice(1)
}


body.isArrayEmpty = (arr) => {
  return arr.length <= 0 ? true : false;
}

export default body;
